import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { OFFLINE_MESSAGE } from '../lib/apiClient';

/**
 * App-wide "you are offline" bar. One banner mounted once in App beats an
 * offline branch on every page, and it stays on screen for as long as the
 * connection is down — which is the thing the stale "Loading..." placeholders
 * and reset-to-0 counts never told the user.
 *
 * role="status" so screen readers announce it, and the message carries an icon
 * plus text rather than relying on the amber colour alone.
 */
export const OfflineBanner: React.FC = () => {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 inset-x-0 z-[1000] flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-center text-xs font-semibold text-white shadow-md"
    >
      <span aria-hidden="true">⚠</span>
      <span>{OFFLINE_MESSAGE}</span>
    </div>
  );
};

export default OfflineBanner;
